(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const closeBtn = document.querySelector('.announcement-bar .top-bar-cross');
    const announcementBar = document.querySelector('.announcement-bar');

    if (!closeBtn || !announcementBar) return;

    closeBtn.addEventListener('click', () => {
      announcementBar.style.display = 'none';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product-teaser"] && !Shopify.designMode) return;
  try {
    
  function initHeroProductTeaser() {
    // ─── Hero Jars Swiper Initialization ──────────────────────────────────────
    const heroMainSlider = document.querySelector('.hero-main-slider');
    const heroThumbEl = document.querySelector('.hero-thumb-slider');
    let heroThumbs = null;
    let heroSwiper = null;

    if (heroMainSlider) {
      // .swiper-slide-duplicate clones in the DOM and corrupt the slide count.
      if (heroMainSlider.swiper) {
        heroMainSlider.swiper.destroy(true, true);
      }
      if (heroThumbEl && heroThumbEl.swiper) {
        heroThumbEl.swiper.destroy(true, true);
      }

      // ── Count only REAL slides (never loop-duplicate clones) ──
      const totalSlides = heroMainSlider.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

      function safeSPV(desired) {
        return Math.max(1, Math.min(desired, totalSlides));
      }
      function loopOk(spv) {
        return totalSlides >= spv * 2; // Swiper's own minimum for a clean loop
      }

      const desktopSPV = safeSPV(3);
      const mobileSPV = safeSPV(1);
      const shouldLoop = totalSlides > 1 && loopOk(desktopSPV);

      const wrapperEl = heroMainSlider.querySelector('.swiper-wrapper');
      const thumbWrapperEl = heroThumbEl.querySelector('.swiper-wrapper');

      function padSlidesForLoop(wrapper, minRequired) {
        const originals = Array.from(wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'));
        let i = 0;
        while (wrapper.querySelectorAll('.swiper-slide').length < minRequired) {
          const clone = originals[i % originals.length].cloneNode(true);
          clone.classList.add('swiper-slide-duplicate-manual');
          wrapper.appendChild(clone);
          i++;
        }
      }

      const minRequired = safeSPV(3) * 2; // e.g. 6 for slidesPerView 3
      padSlidesForLoop(wrapperEl, minRequired);
      padSlidesForLoop(thumbWrapperEl, minRequired);

      if (heroThumbEl) {
        const allTabs = heroThumbEl.querySelectorAll('.tab');
        allTabs.forEach((tab, index) => {
          tab.dataset.slideTo = index;
        });
      }

      // Thumbnail slider
      heroThumbs = new Swiper('.hero-thumb-slider', {
        slidesPerView: desktopSPV,
        centeredSlides: true,
        spaceBetween: 0,
        watchSlidesProgress: true,
        speed: 600,
        loop: shouldLoop,
      });

      let queuedSteps = 0;
      let queuedDirection = 1;

      function stepQueue() {
        if (queuedSteps <= 0) return;
        queuedSteps--;
        if (queuedDirection > 0) {
          heroSwiper.slideNext();
        } else {
          heroSwiper.slidePrev();
        }
      }

      // Main slider
      heroSwiper = new Swiper('.hero-main-slider', {
        slidesPerView: mobileSPV,
        centeredSlides: true,
        initialSlide: totalSlides > 1 ? 1 : 0,
        speed: 600,
        loop: shouldLoop,
        allowTouchMove: true,

        breakpoints: {
          0: {
            slidesPerView: mobileSPV,
            centeredSlides: true,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: mobileSPV,
            centeredSlides: true,
            spaceBetween: 0,
          },
          992: {
            slidesPerView: desktopSPV,
            centeredSlides: true,
            spaceBetween: 0,
          },
        },

        on: {
          init: function () {
            updateTabs(this.realIndex);
          },
          slideChange: function () {
            updateTabs(this.realIndex);
            if (heroThumbs) {
              if (shouldLoop) {
                heroThumbs.slideToLoop(this.realIndex);
              } else {
                heroThumbs.slideTo(this.realIndex);
              }
            }
          },
          slideChangeTransitionEnd: function () {
            updateActiveFruit();
            stepQueue();
          },
        },
      });

      const tabEls = document.querySelectorAll('.hero-thumb-slider .tab');
      const totalTabs = tabEls.length;

      tabEls.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          if (queuedSteps > 0 || heroSwiper.animating) {
            return;
          }

          const target = Number(tab.dataset.slideTo);
          const current = heroSwiper.realIndex;

          if (target === current) return;

          let diff = target - current;

          if (diff > totalTabs / 2) {
            diff -= totalTabs;
          } else if (diff < -totalTabs / 2) {
            diff += totalTabs;
          }

          queuedDirection = diff > 0 ? 1 : -1;
          queuedSteps = Math.abs(diff);
          stepQueue();
        });
      });

      let thumbsTouchStartX = 0;
      let thumbsMaxDragDistance = 0;
      const DRAG_THRESHOLD = 10; // px

      heroThumbs.on('touchStart', (swiper, event) => {
        thumbsMaxDragDistance = 0;
        const point = event.touches ? event.touches[0] : event;
        thumbsTouchStartX = point.clientX;
      });

      heroThumbs.on('touchMove', (swiper, event) => {
        const point = event.touches ? event.touches[0] : event;
        const distance = Math.abs(point.clientX - thumbsTouchStartX);
        if (distance > thumbsMaxDragDistance) {
          thumbsMaxDragDistance = distance;
        }
      });

      heroThumbs.on('touchEnd', () => {
        if (thumbsMaxDragDistance < DRAG_THRESHOLD) return; // ignore taps/clicks, only real drags pass

        if (heroSwiper.animating || queuedSteps > 0) return;

        const target = heroThumbs.realIndex;
        const current = heroSwiper.realIndex;
        if (target === current) return;

        let diff = target - current;
        if (diff > totalTabs / 2) {
          diff -= totalTabs;
        } else if (diff < -totalTabs / 2) {
          diff += totalTabs;
        }

        queuedDirection = diff > 0 ? 1 : -1;
        queuedSteps = Math.abs(diff);
        stepQueue();
      });

      function updateTabs(activeIndex) {
        const tabs = document.querySelectorAll('.hero-thumb-slider .swiper-slide');
        tabs.forEach((tab, index) => {
          tab.classList.toggle('active-tab', index === activeIndex);
        });
      }

      function updateActiveFruit() {
        const activeSlide = document.querySelector('.hero-main-slider .hero-slide.swiper-slide-active');

        if (!activeSlide) return;

        const fruitType = activeSlide.dataset.fruitType;

        document.querySelectorAll('.hero-fruit').forEach((fruit) => {
          fruit.classList.toggle('active', fruit.dataset.fruitType === fruitType);

          // Remove glow when slider changes
          fruit.classList.remove('is-glowing');
        });
      }
    }
  }

  // wait for the Swiper library to actually be available before initializing
  function initHeroProductTeaserWhenReady(retries) {
    if (retries === undefined) retries = 30;

    if (typeof Swiper === 'undefined') {
      if (retries <= 0) {
        console.error('Swiper library never loaded — hero slider not initialized');
        return;
      }
      setTimeout(function () {
        initHeroProductTeaserWhenReady(retries - 1);
      }, 100);
      return;
    }

    initHeroProductTeaser();
  }

  if (document.readyState !== 'loading') {
    initHeroProductTeaserWhenReady();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initHeroProductTeaserWhenReady();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-recipes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  let recipeSwiper;

  function initRecipeSlider() {
    if (window.innerWidth <= 767) {
      if (!recipeSwiper) {
        recipeSwiper = new Swiper('.receipe-listings-slider', {
          spaceBetween: 16,
          loop: true,
          breakpoints: {
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 1.5,
            },
          },
        });
      }
    } else {
      if (recipeSwiper) {
        recipeSwiper.destroy(true, true);
        recipeSwiper = undefined;
      }
    }
  }

  initRecipeSlider();
  window.addEventListener('resize', initRecipeSlider);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  // Select all counter elements
  const counters = document.querySelectorAll('.counter-number .count');
  if (!counters.length) return;

  const ANIMATION_DURATION = 2000; // ms

  // Extract number + prefix/suffix from data-target
  const getTargetParts = (element) => {
    const parent = element.closest('.counter-number');
    if (!parent) return null;

    const raw = (parent.getAttribute('data-target') || '').trim();
    const match = raw.match(/[\d.,]+/);

    if (!match) return null;

    const numStr = match[0].replace(/,/g, '');
    const value = Number(numStr);

    if (!Number.isFinite(value)) return null;

    return {
      value,
      decimals: numStr.includes('.') ? (numStr.split('.')[1] || '').length : 0,
      useGrouping: match[0].includes(','),
      prefix: raw.slice(0, match.index),
      suffix: raw.slice(match.index + match[0].length),
    };
  };

  // Format number back with prefix/suffix
  const format = (num, parts) =>
    parts.prefix +
    num.toLocaleString('en-US', {
      minimumFractionDigits: parts.decimals,
      maximumFractionDigits: parts.decimals,
      useGrouping: parts.useGrouping,
    }) +
    parts.suffix;

  // Build counter data once
  const counterData = [...counters].map((counter) => ({
    element: counter,
    parts: getTargetParts(counter),
  }));

  let animationStarted = false;

  const animateAllCounters = () => {
    if (animationStarted) return;
    animationStarted = true;

    const startTime = performance.now();

    const update = (currentTime) => {
      const progress = Math.min(
        (currentTime - startTime) / ANIMATION_DURATION,
        1
      );

      counterData.forEach(({ element, parts }) => {
        if (!parts) return;

        const currentValue = parts.value * progress;
        element.textContent = format(currentValue, parts);
      });

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        counterData.forEach(({ element, parts }) => {
          if (!parts) return;

          element.textContent = format(parts.value, parts);
        });
      }
    };

    requestAnimationFrame(update);
  };

  // Observe the first visible counter section
  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        animateAllCounters();
        observer.disconnect();
      }
    },
    {
      threshold: 0.2,
    }
  );

  // Observe each counter wrapper
  document.querySelectorAll('.counter-number').forEach((wrapper) => {
    observer.observe(wrapper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["team"] && !Shopify.designMode) return;
  try {
    
  
 // Modal off-canvas toggle logic using the new `is-open` and `is-visible` BEM modifiers.
  document.addEventListener('DOMContentLoaded', () => {
    const openBtns = document.querySelectorAll(
      '.team-block-member'
    );

    const overlay =
      document.querySelector('.overlay');

    let activeTrigger = null;
    let activeOffCanvas = null;

    function openModal(btn) {
      const targetId =
        btn.getAttribute('aria-controls');

      const offCanvas =
        document.getElementById(targetId);

      if (!offCanvas) return;

      activeTrigger = btn;
      activeOffCanvas = offCanvas;

      offCanvas.classList.add('is-open');
      overlay?.classList.add('is-visible');
      document.body.classList.add(
        'popup-overflow-hidden'
      );

      btn.setAttribute(
        'aria-expanded',
        'true'
      );

      const closeBtn =
        offCanvas.querySelector(
          '.off-canvas__close-btn'
        );

      setTimeout(() => closeBtn?.focus(), 300);
    }

    function closeModal() {
      if (!activeOffCanvas) return;

      activeOffCanvas.classList.remove(
        'is-open'
      );

      overlay?.classList.remove(
        'is-visible'
      );

      document.body.classList.remove(
        'popup-overflow-hidden'
      );

      if (activeTrigger) {
        activeTrigger.setAttribute(
          'aria-expanded',
          'false'
        );

        activeTrigger.focus();
      }

      activeOffCanvas = null;
    }

    openBtns.forEach((btn) => {
      btn.addEventListener('click', () =>
        openModal(btn)
      );
    });

    document.addEventListener('click', (e) => {
      if (
        e.target.closest(
          '.off-canvas__close-btn'
        )
      ) {
        closeModal();
      }
    });

    overlay?.addEventListener(
      'click',
      closeModal
    );

    document.addEventListener(
      'keydown',
      (e) => {
        if (
          e.key === 'Escape' &&
          activeOffCanvas?.classList.contains(
            'is-open'
          )
        ) {
          closeModal();
        }
      }
    );
  });

  } catch(e) { console.error(e); }
})();
})();
